export default "__VITE_ASSET__QMlT92KW__"